import { createPortal } from 'react-dom'

import { getPopupLayerElement } from './PopupLayer'

/**
 * Prevent event bubbling
 * @see https://reactjs.org/docs/portals.html#event-bubbling-through-portals
 */
const stopPropagation = (e: React.SyntheticEvent) => {
  e.stopPropagation()
}

export default function Popup(props: { children: React.ReactNode }) {
  return createPortal(<div onClick={stopPropagation}>{props.children}</div>, getPopupLayerElement())
}
